module.exports = __webpack_public_path__ + "img/helmet-battle.fd4481ae.svg";